/**
 * [ File :: B_TweenObject.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/animate/tween/B_TweenObject.js
 * @목적 : Tween 메소드 명세
 * @진행 : 개발종료 (필요시추가)
 * @주의 : 해당 "B_" 파일에는 공용적으로 사용하는 Tween 메소드만을 추가 해주세요.
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Tween from 'canvas/base/dev/animate/tween/B_Tween';

const B_TweenObject = (function(){

	return class B_TweenObject extends B_Tween {

		constructor(canvas) { super(canvas); }

		/**
		 * [ Function :: downToCenter ]
		 *
		 * DES :: [생성] 아래서 가운데로
		 * INP ::
		 * OUT ::
		 * S.E ::
		 */
		downToCenter(obj, time, cb) {
			obj._active  = true; // # 활성 처리 (활성)
			obj._visible = true; // # 투명 처리 (보임)
			obj._alpha   = 0;    // # 알파 설정 (투명도)
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							x     : obj._getGridPixelX(),
							y     : obj._getGridPixelY() + obj._gridDisY / 2,
							alpha : 0
						},
						time   : 0,
						effect : "none"
					},
					// STEP02
					{
						option : {
							x     : obj._getGridPixelX(),
							y     : obj._getGridPixelY(),
							alpha : 1
						},
						time   : time,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: centerToTop ]
		 *
		 * DES :: [삭제] 가운데서 위로
		 * INP ::
		 * OUT ::
		 * S.E ::
		 */
		centerToTop(obj, cb) {
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							x     : obj._getGridPixelX(),
							y     : obj._getGridPixelY() - obj._gridDisY / 2,
							alpha : 0
						},
						time   : this.getCanvas().time,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: centerToDown ]
		 *
		 * DES :: [삭제] 가운데서 위로
		 * INP ::
		 * OUT ::
		 * S.E ::
		 */
		centerToDown(obj, time, cb) {
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							x     : obj._getGridPixelX(),
							y     : obj._getGridPixelY() + obj._gridDisY / 2,
							alpha : 0
						},
						time   : time,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: portalUp ]
		 *
		 * DES :: 포탈 상승 효과 (포탈이벤트의 절반)
		 * INP ::
		 * OUT ::
		 * S.E :: B_._disY, B_.time, "bounceIn"
		 */
		portalUp(obj, cb) {
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							y     : obj._pixelY - obj._gridDisY / 2,
							alpha : 0
						},
						time   : this.getCanvas().time / 2,
						effect : "bounceIn"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: portalDown ]
		 *
		 * DES :: 포탈 하강 효과 (포탈이벤트의 절반)
		 * INP ::
		 * OUT ::
		 * S.E :: this.getCanvas()._disY, this.getCanvas().time, "bounceIn"
		 */
		portalDown(obj, x, y, cb) {
			// # default
			if(!x) x = obj.getPixelX();
			if(!y) y = obj.getPixelY();

			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							x     : x,
							y     : y - obj._gridDisY / 2,
							alpha : 0
						},
						time   : 0,
						effect : "none"
					},
					// STEP02
					{
						option : {
							y     : y,
							alpha : 1
						},
						time   : this.getCanvas().time / 2,
						effect : "bounceOut"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: portal ]
		 *
		 * DES :: 포탈 효과
		 * INP ::
		 * OUT ::
		 * S.E :: this.getCanvas()._disY, this.getCanvas().time, "bounceIn"
		 */
		portal(obj, x, y, cb) {
			this.portalUp(obj, (tween) => {
				this.portalDown(obj, x, y, () => {
					if(cb) cb(tween);
				});
			});
		}

		/**
		 * [ Function :: landing ]
		 *
		 * DES :: 착륙 효과 (하늘로부터)
		 * INP ::
		 * OUT ::
		 * S.E ::
		 */
		landing(obj, cb) {
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							y     : obj._pixelY - this.getCanvas().CANVAS.height
						},
						time   : 0,
						effect : "none"
					},
					// STEP02
					{
						option : {
							y     : obj._pixelY
						},
						time   : this.getCanvas().time * 1,
						effect : "bounceOut"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: launching ]
		 *
		 * DES :: 이륙 효과 (바닥으로부터)
		 * INP ::
		 * OUT ::
		 * S.E ::
		 */
		launching(obj, cb) {
			this.tween(obj, null, {
				arrStep : [
					// STEP01
					{
						option : {
							y     : obj._pixelY
						},
						time   : 0,
						effect : "none"
					},
					// STEP02
					{
						option : {
							y     : obj._pixelY - this.getCanvas().CANVAS.height
						},
						time   : this.getCanvas().time * 1,
						effect : "bounceOut"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: move ]
		 *
		 * @DES :: 움직이기
		 * @INP :: obj[obj], act[str], x[num], y[num], cb[func]
		 * @OUT :: tween[obj]
		 * @S.E ::
		 */
		move(obj, act, x, y, cb) {
			this.tween(obj, act, {
				arrStep : [
					{
						option : {
							x : x,
							y : y
						},
						time : this.getCanvas().time,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: crush ]
		 *
		 * @DES :: 충돌하기
		 * @IP1 :: obj[obj]
		 * @IP2 :: act[str]
		 * @IP3 :: frontX[num]
		 * @IP4 :: frontY[num]
		 * @IP5 :: backX[num]
		 * @IP6 :: backY[num]
		 * @IP7 :: cb[func]
		 * @O.P :: tween[obj]
		 * @S.E ::
		 */
		crush(obj, act, frontX, frontY, backX, backY, cb){
			setTimeout(() => {
					this.getCanvas().SOUND.play('crush')
				}, this.getCanvas().time / 2);

			this.tween(obj, act, {
				arrStep : [
					{
						option : {
							x : frontX,
							y : frontY
						},
						time : this.getCanvas().time / 2,
						effect : "none"
					},
					{
						option : {
							x : backX,
							y : backY
						},
						time : this.getCanvas().time / 2,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

		/**
		 * [ Function :: beStepped ]
		 *
		 * @DES :: 밟힘 애니메이션
		 * @IP1 :: obj[obj]
		 * @IP2 :: cb[func]
		 * @O.P :: tween[obj]
		 * @S.E ::
		 */
		beStepped(obj, cb){
			this.tween(obj, null, {
				arrStep : [
					{
						wait   : this.getCanvas().time / 2,
					},
					{
						option : {
							y : obj._getGridPixelY() + (obj._gridDisY / 20)
						},
						time : this.getCanvas().time / 4,
						effect : "none"
					},
					{
						option : {
							y : obj._getGridPixelY()
						},
						time : this.getCanvas().time / 4,
						effect : "none"
					}
				]
			}, (tween) => {
				if(cb) cb(tween);
			});
		}

	}
}());

export default B_TweenObject;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/animate/tween/B_TweenObject.js